export function calculateDisplayedProgress(previous: number, current: number): number {
  if (current == null) {
    return 0;
  }

  if (current === 100) {
    return 100;
  }

  const diff = current - previous;
  if (diff > 0) {
    return previous + diff / 10;
  }

  return previous;
}
